<template>
  <page-view :is-loading="loading">
    <template #header>
      <base-header
        :title="'DRM'"
        :subtitle="selectedDrmGroup.name"
        :isMobileBreakpoint="isMobileBreakpoint"
        @title="handleBackToListing"
        @back="handleBackToListing"
      >
        <template #status>
          <base-progress-circular
            v-if="isLoadingCsvComputed"
          ></base-progress-circular>
          <v-tag
            class="converting-chip ml-2"
            size="small"
            v-if="isLoadingCsvComputed"
            >{{ $t('message.pages.drm.loadingImportCsv.loading') }}</v-tag
          ></template
        >
        <template #actions>
          <span>
            <base-btn
              v-if="!isMobileBreakpoint"
              type="tertiary"
              @click="addKey"
            >
              {{ $t('message.pages.drm.addKey') }}
            </base-btn>
            <base-btn
              v-if="!isMobileBreakpoint"
              @click="openModal"
              style="margin-left: 1rem"
            >
              {{ $t('message.pages.drm.addVideo') }}
            </base-btn>
          </span>
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="iconElement" icon small v-bind="attrs" v-on="on">
                <v-icon small>panda-menu-action</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="hasIncompleteIntegration(selectedDrmGroup) ? on : {}"
                    style="width: 100%"
                  >
                    <v-list-item
                      @click="handleActivationGroup(selectedDrmGroup)"
                      :disabled="hasIncompleteIntegration(selectedDrmGroup)"
                    >
                      <span class="body-regular-smaller">
                        {{
                          selectedDrmGroup.active
                            ? $t('message.pages.drm.disableDrm')
                            : $t('message.pages.drm.activeDrm')
                        }}
                      </span>
                    </v-list-item>
                  </div>
                </template>
                <span
                  v-if="hasIncompleteIntegration(selectedDrmGroup)"
                  style="white-space: pre-line"
                  class="body-regular-smaller"
                >
                  {{ $t('message.pages.drm.disabledGroupTooltip') }}
                </span>
              </v-tooltip>
              <v-list-item @click="openEditIngration">
                <span class="body-regular-smaller">
                  {{ $t('message.pages.drm.editIntegration') }}
                </span>
              </v-list-item>

              <v-divider></v-divider>
              <v-list-item @click="handleDeleteGroup(selectedDrmGroup)">
                <span
                  class="body-regular-smaller"
                  style="height: 100%; color: #f44336"
                >
                  {{ $t('message.pages.drm.removeDrm') }}
                </span>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </base-header>
    </template>
    <template #content>
      <div class="grid">
        <!-- embed -->
        <div v-if="isMobileBreakpoint" style="overflow: auto">
          <div class="grid__preview">
            <div class="grid__preview--container">
              <div
                class="video-container"
                style="
                  position: relative;
                  width: 100%;
                  max-width: 800px;
                  margin: 0 auto;
                  overflow: hidden;
                "
              >
                <div
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                  "
                >
                  <div
                    v-if="!questionComputed"
                    :key="currentPosition"
                    :style="getBoxStyle"
                    :class="getAnimationClass"
                    class="box"
                  >
                    <div>{{ boxLines.text1 }}: {{ boxLines.text1 }}</div>
                    <div>{{ boxLines.text2 }}</div>
                    <div>{{ boxLines.text3 }}</div>
                  </div>

                  <div
                    v-if="questionComputed && !isMobileBreakpoint"
                    style="
                      width: 658px;
                      border-radius: 8px;
                      padding: 24px;
                      margin-top: 135px;
                      margin-left: 85px;
                      background-color: white;
                    "
                    class="neutral-100-white"
                  >
                    <div class="d-flex flex-column">
                      <span class="body-bold-medium neutral-20-dark--text">
                        {{ question ? question : 'Digite seu e-mail' }}
                      </span>
                      <span class="body-regular-smaller neutral-40-light--text">
                        O vídeo será desbloqueado após a confirmação da sua
                        identidade
                      </span>
                    </div>
                    <v-divider class="my-7" />
                    <div class="d-flex">
                      <v-input
                        hide-details
                        placeholder="Digite aqui"
                        class="mr-2"
                      ></v-input>
                      <base-btn disabled>Confirmar</base-btn>
                    </div>
                  </div>
                </div>
                <div class="grid__preview--container" v-html="embedPage"></div>
              </div>
            </div>
            <div>
              <BaseAlert
                v-if="isLoadingCsvComputed"
                class="my-8"
                type="informative"
                :title="$t('message.pages.drm.importCsvModal.title')"
                :description="
                  $t('message.pages.drm.importCsvModal.description')
                "
              >
                <base-btn size="small" type="secondary">{{
                  $t('message.embedModal.knowMore')
                }}</base-btn>
              </BaseAlert>
            </div>
            <div class="grid__details">
              <div class="body-label-caption neutral-40-light--text mb-2">
                {{ $t('message.pages.drm.integrationData').toUpperCase() }}
              </div>
              <div style="width: 100%">
                <label
                  style="font-size: 12px"
                  class="body-label-xs neutral-20-dark--text mb-0"
                  >{{ $t('message.pages.drm.name') }}</label
                >
                <v-input
                  class="input-name"
                  :value="selectedDrmGroup.name"
                  hide-details
                  readonly
                />
              </div>
              <div>
                <label
                  style="font-size: 12px"
                  class="body-label-xs neutral-20-dark--text mb-0"
                  >{{ $t('message.pages.drm.platform') }}</label
                >
                <v-input readonly :value="platformLabel" hide-details>
                  <template #prepend-inner>
                    <img
                      :src="platformSvg"
                      alt="Logo"
                      style="height: 16px; margin-right: 4px; margin-top: 2px"
                    />
                  </template>
                </v-input>
              </div>
              <div
                class="w-full"
                v-if="['hotmart', 'eduzz'].includes(selectedSourceWebhook)"
              >
                <label
                  style="font-size: 12px"
                  class="body-label-xs neutral-20-dark--text mb-0"
                  >{{ $t('message.pages.drm.urlIntegration') }}</label
                >
                <div class="d-flex justify-space-between">
                  <v-input
                    readonly
                    :value="`https://api-v2.pandavideo.com.br/drm/webhook/${selectedDrmGroup.id}`"
                    hide-details
                  />
                  <v-btn
                    icon
                    @click="
                      copyToClipboard(
                        `https://api-v2.pandavideo.com.br/drm/webhook/${selectedDrmGroup.id}`
                      )
                    "
                  >
                    <v-icon size="16">panda-copy</v-icon>
                  </v-btn>
                </div>
              </div>
              <div
                class="w-full"
                v-if="
                  !['hotmart', 'eduzz', 'xgrow', 'memberkit'].includes(
                    selectedSourceWebhook
                  )
                "
              >
                <label
                  style="font-size: 12px"
                  class="body-label-xs neutral-20-dark--text mb-0"
                  >{{ $t('message.pages.drm.groupId') }}</label
                >
                <div class="d-flex justify-space-between">
                  <v-input readonly :value="selectedDrmGroup.id" hide-details />
                  <v-btn icon @click="copyToClipboard">
                    <v-icon size="16">panda-copy</v-icon>
                  </v-btn>
                </div>
              </div>
              <div
                class="w-full"
                v-if="
                  !['hotmart', 'eduzz', 'xgrow', 'memberkit'].includes(
                    selectedSourceWebhook
                  )
                "
              >
                <label
                  style="font-size: 12px"
                  class="body-label-xs neutral-20-dark--text mb-0"
                  >{{ $t('message.pages.drm.secretKey') }}</label
                >
                <div class="d-flex justify-space-between">
                  <v-input
                    readonly
                    :value="
                      showSecret
                        ? selectedDrmGroup.secret
                        : '************************************'
                    "
                    hide-details
                  />
                  <v-btn icon @click="showSecret = !showSecret">
                    <v-icon size="16">{{
                      showSecret ? 'mdi-eye-off' : 'mdi-eye'
                    }}</v-icon>
                  </v-btn>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                  align-items: center;
                "
                :class="{
                  'flex-column': isMobileBreakpoint,
                  'align-start': isMobileBreakpoint,
                }"
              >
                <div>
                  <label
                    style="font-size: 12px"
                    class="body-label-xs neutral-20-dark--text mb-0"
                    >Status</label
                  >
                  <v-switch
                    v-model="selectedDrmGroup.active"
                    class="mt-0"
                    :label="
                      selectedDrmGroup.active
                        ? $t('message.affiliateVideoPage.enabled')
                        : $t('message.deactivated')
                    "
                    :disabled="hasIncompleteIntegration(selectedDrmGroup)"
                    @click="handleStatusDRM"
                    hide-details
                  />
                </div>
                <base-btn
                  :class="{ 'mt-4': isMobileBreakpoint }"
                  type="tertiary"
                  @click="openEditIngration"
                >
                  {{ $t('message.pages.drm.editIntegration') }}
                </base-btn>
              </div>
            </div>
          </div>

          <div class="grid__control">
            <drm-tabs></drm-tabs>

            <!-- settings::watermark -->
            <portal to="watermark-tab"
              ><drm-watermark
                style="padding-left: 8px"
                :selectedDrmGroup="selectedDrmGroup"
                :selectedSourceWebhook="selectedSourceWebhook"
                :startWebhookValue="startWebhookValue"
            /></portal>

            <!-- settings::videos -->
            <portal to="videos-tab"
              ><drm-videos
                :allDrmGroups="allDrmGroups"
                :selectedDrmGroup="selectedDrmGroup"
              />
            </portal>
            <!-- settings::keys-security -->
            <portal to="keys-security-tab" slim
              ><drm-list-keys
                :selectedDrmGroup="selectedDrmGroup"
                :selectedSourceWebhook="selectedSourceWebhook"
              />
            </portal>

            <!-- settings::apparence -->
            <portal to="apparence-tab"
              ><drm-apparence
                style="padding-left: 8px"
                :selectedDrmGroup="selectedDrmGroup"
              />
            </portal>

            <!-- settings::level-security -->
            <portal to="level-security-tab"
              ><drm-level-security
                style="padding-left: 8px"
                :selectedDrmGroup="selectedDrmGroup"
              />
            </portal>
          </div>
        </div>
        <div class="grid__preview" v-if="!isMobileBreakpoint">
          <div class="grid__preview--container">
            <div
              class="video-container"
              style="
                position: relative;
                width: 100%;
                max-width: 900px;
                margin: 0 auto;
                overflow: hidden;
                border-radius: 4px;
              "
            >
              <div
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 1;
                  overflow: hidden;
                "
              >
                <div
                  v-if="!questionComputed"
                  :key="currentPosition"
                  :style="getBoxStyle"
                  :class="getAnimationClass"
                  class="box"
                >
                  <div>{{ boxLines.text1 }}: {{ boxLines.text1 }}</div>
                  <div>{{ boxLines.text2 }}</div>
                  <div>{{ boxLines.text3 }}</div>
                </div>

                <div
                  v-if="questionComputed"
                  style="
                    width: 658px;
                    border-radius: 8px;
                    padding: 24px;
                    margin-top: 135px;
                    margin-left: 85px;
                  "
                  class="neutral-100-white"
                >
                  <div class="d-flex flex-column">
                    <span class="body-bold-medium neutral-20-dark--text">
                      {{ question ? question : 'Digite seu e-mail' }}
                    </span>
                    <span class="body-regular-smaller neutral-40-light--text">
                      O vídeo será desbloqueado após a confirmação da sua
                      identidade
                    </span>
                  </div>
                  <v-divider class="my-7" />
                  <div class="d-flex">
                    <v-input
                      hide-details
                      placeholder="Digite aqui"
                      class="mr-2"
                    ></v-input>
                    <base-btn disabled>Confirmar</base-btn>
                  </div>
                </div>
              </div>
              <div class="grid__preview--container" v-html="embedPage"></div>
            </div>
          </div>
          <div>
            <BaseAlert
              v-if="isLoadingCsvComputed"
              class="my-8"
              type="informative"
              :title="'Importando novas chaves de segurança'"
              :description="'A ativação das novas chaves podem levar alguns minutos'"
            >
              <base-btn size="small" type="secondary">{{
                $t('message.embedModal.knowMore')
              }}</base-btn>
            </BaseAlert>
          </div>
          <div class="grid__details">
            <div class="body-label-caption neutral-40-light--text mb-2">
              {{ $t('message.pages.drm.integrationData').toUpperCase() }}
            </div>
            <div style="width: 100%">
              <label
                style="font-size: 12px"
                class="body-label-xs neutral-20-dark--text mb-0"
                >{{ $t('message.pages.drm.name') }}</label
              >
              <v-input
                class="input-name"
                :value="selectedDrmGroup.name"
                hide-details
                readonly
              />
            </div>
            <div class="mt-2">
              <label
                style="font-size: 12px"
                class="body-label-xs neutral-20-dark--text mb-0"
                >{{ $t('message.pages.drm.platform') }}</label
              >
              <v-input readonly :value="platformLabel" hide-details>
                <template #prepend-inner>
                  <img
                    :src="platformSvg"
                    alt="Logo"
                    style="height: 16px; margin-right: 4px; margin-top: 2px"
                  />
                </template>
              </v-input>
            </div>
            <div
              class="w-full"
              v-if="['hotmart', 'eduzz'].includes(selectedSourceWebhook)"
            >
              <label
                style="font-size: 12px"
                class="body-label-xs neutral-20-dark--text mb-0"
                >{{ $t('message.pages.drm.urlIntegration') }}</label
              >
              <div class="d-flex justify-space-between">
                <v-input
                  readonly
                  :value="`https://api-v2.pandavideo.com.br/drm/webhook/${selectedDrmGroup.id}`"
                  hide-details
                />
                <v-btn
                  icon
                  @click="
                    copyToClipboard(
                      `https://api-v2.pandavideo.com.br/drm/webhook/${selectedDrmGroup.id}`
                    )
                  "
                >
                  <v-icon size="16">panda-copy</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              class="w-full"
              v-if="
                !['hotmart', 'eduzz', 'xgrow', 'memberkit'].includes(
                  selectedSourceWebhook
                )
              "
            >
              <label
                style="font-size: 12px"
                class="body-label-xs neutral-20-dark--text mb-0"
                >{{ $t('message.pages.drm.groupId') }}</label
              >
              <div class="d-flex justify-space-between">
                <v-input readonly :value="selectedDrmGroup.id" hide-details />
                <v-btn icon @click="copyToClipboard(selectedDrmGroup.id)">
                  <v-icon size="16">panda-copy</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              class="w-full"
              v-if="
                !['hotmart', 'eduzz', 'xgrow', 'memberkit'].includes(
                  selectedSourceWebhook
                )
              "
            >
              <label
                style="font-size: 12px"
                class="body-label-xs neutral-20-dark--text mb-0"
                >{{ $t('message.pages.drm.secretKey') }}</label
              >
              <div class="d-flex justify-space-between">
                <v-input
                  readonly
                  :value="
                    showSecret
                      ? selectedDrmGroup.secret
                      : '************************************'
                  "
                  hide-details
                />
                <v-btn icon @click="showSecret = !showSecret">
                  <v-icon size="16">{{
                    showSecret ? 'mdi-eye-off' : 'mdi-eye'
                  }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 100%;
                align-items: center;
              "
            >
              <div>
                <label
                  style="font-size: 12px"
                  class="body-label-xs neutral-20-dark--text mb-0"
                  >Status</label
                >
                <v-tooltip
                  max-width="184px"
                  top
                  :disabled="!hasIncompleteIntegration(selectedDrmGroup)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-switch
                        v-model="selectedDrmGroup.active"
                        :disabled="hasIncompleteIntegration(selectedDrmGroup)"
                        class="mt-0"
                        :label="
                          selectedDrmGroup.active
                            ? $t('message.affiliateVideoPage.enabled')
                            : $t('message.deactivated')
                        "
                        @click="handleStatusDRM"
                        hide-details
                      />
                    </div>
                  </template>
                  <span>{{
                    $t('message.pages.drm.disabledGroupTooltip')
                  }}</span>
                </v-tooltip>
              </div>
              <base-btn
                v-if="!isMobileBreakpoint"
                type="tertiary"
                @click="openEditIngration"
              >
                {{ $t('message.pages.drm.editIntegration') }}
              </base-btn>
            </div>
          </div>
        </div>

        <div class="grid__control" v-if="!isMobileBreakpoint">
          <drm-tabs></drm-tabs>

          <!-- settings::watermark -->
          <portal to="watermark-tab"
            ><drm-watermark
              style="padding-left: 8px"
              :selectedDrmGroup="selectedDrmGroup"
              :selectedSourceWebhook="selectedSourceWebhook"
              :startWebhookValue="startWebhookValue"
          /></portal>

          <!-- settings::videos -->
          <portal to="videos-tab"
            ><drm-videos :selectedDrmGroup="selectedDrmGroup"
          /></portal>
          <!-- settings::keys-security -->
          <portal to="keys-security-tab" slim
            ><drm-list-keys
              :selectedDrmGroup="selectedDrmGroup"
              :selectedSourceWebhook="selectedSourceWebhook"
            />
          </portal>

          <!-- settings::apparence -->
          <portal to="apparence-tab"
            ><drm-apparence
              style="padding-left: 8px"
              :selectedDrmGroup="selectedDrmGroup"
            />
          </portal>

          <!-- settings::level-security -->
          <portal to="level-security-tab"
            ><drm-level-security
              style="padding-left: 8px"
              :selectedDrmGroup="selectedDrmGroup"
            />
          </portal>
        </div>
        <!-- <div class="grid__spacer spacer"></div> -->
        <!-- plyr::actions -->
        <div class="grid__footer d-flex flex-column actions-column">
          <div class="divider-div">
            <v-divider></v-divider>
          </div>
          <div class="d-flex flex-row actions-row">
            <v-spacer></v-spacer>
            <v-tooltip
              v-if="
                (savedTab != 1 && isMobileBreakpoint) || !isMobileBreakpoint
              "
              max-width="184px"
              top
              :disabled="!noChanges"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    type="tertiary"
                    @click="discardChanges"
                    :disabled="noChanges || isBtnloading"
                  >
                    {{ $t('message.actions.cancel') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="
                (savedTab != 1 && isMobileBreakpoint) || !isMobileBreakpoint
              "
              max-width="184px"
              top
              :disabled="!noChanges"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    @click="publish"
                    :disabled="noChanges || isBtnloading || emptyInput"
                    :loading="isBtnloading"
                  >
                    {{ $t('message.actions.publish') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>

            <base-btn
              v-if="savedTab == 1 && isMobileBreakpoint"
              type="secondary"
              width="284px"
              @click="openModal"
              >{{ $t('message.pages.drm.addVideo') }}</base-btn
            >
          </div>
        </div>
      </div>
      <drm-create-secret-key />
      <drm-remove-group />
      <drm-activation-group />
      <drm-add-video
        :openSelectPanda="openSelectPanda"
        :selectedGroup="selectedDrmGroup"
        :allDrmGroups="allDrmGroups"
        @update:openSelectPanda="openSelectPanda = $event"
      />
      <drm-integration-flow />
    </template>
  </page-view>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import DrmApparence from './DrmSettings/DrmApparence.vue'
import DrmActivationGroup from './DrmActivationGroup.vue'
import DrmRemoveGroup from './DrmRemoveGroup.vue'
import DrmTabs from './DrmTabs.vue'
import DrmLevelSecurity from './DrmSettings/DrmLevelSecurity.vue'
import drmApi from '@/services/drmApi'
import utilsMixin from '@/utils/utils.mixin'
import DrmListKeys from './DrmSettings/DrmListKeys.vue'
import DrmCreateSecretKey from './DrmCreateSecretKey.vue'
import DrmAddVideo from './DrmSettings/DrmAddVideo.vue'
import i18n from '@/translations/lang'
import BaseAlert from '../../components/BaseAlert.vue'
import hotmart from '@/assets/pandaIcons/plataformas-hotmart.svg'
import eduzz from '@/assets/pandaIcons/plataformas-eduzz.svg'
import memberkit from '@/assets/pandaIcons/plataformas-memberkit.svg'
import themembers from '@/assets/pandaIcons/plataformas-the-members.svg'
import ticto from '@/assets/pandaIcons/plataformas-ticto.svg'
import cademi from '@/assets/pandaIcons/plataformas-cademi.svg'
import xgrow from '@/assets/pandaIcons/plataformas-xgrow.svg'
import api from '@/assets/pandaIcons/plataformas-api.svg'
import DrmIntegrationFlow from './DrmIntegrationFlow.vue'
export default {
  name: 'DRM',
  mixins: [utilsMixin],
  components: {
    pageView: () => import('@/layout/VideoPage/PageView_VideoPage.vue'),
    BaseHeader: () => import('@/layout/VideoPage/BaseHeader_VideoPage.vue'),
    DrmWatermark: () => import('./DrmSettings/DrmWatermark.vue'),
    DrmVideos: () => import('./DrmSettings/DrmVideos.vue'),
    BaseProgressCircular: () =>
      import('@/components/BaseComponents/BaseProgressCircular.vue'),
    DrmTabs,
    DrmApparence,
    DrmLevelSecurity,
    DrmListKeys,
    DrmCreateSecretKey,
    DrmAddVideo,
    BaseAlert,
    DrmIntegrationFlow,
    DrmActivationGroup,
    DrmRemoveGroup,
  },
  data() {
    return {
      showSecret: false,
      showMenu: false,
      language: this.$i18next.resolvedLanguage,
      pandaBranding: true,
      isBtnloading: false,
      startWebhookValue: {},
      selectedWebhookValue: {},
      selectedSourceWebhook: 'api',
      selectedDrmGroupState: {},
      hottok: '',
      emptyInput: false,
      isLoadingCsv: false,
      openSelectPanda: false,
      loading: false,
      allDrmGroupsState: [],
      eventPublish: [
        'watermark-tab',
        'videos-tab',
        'keys-security-tab',
        'apparence-tab',
        'level-security-tab',
      ],
      boxLines: {
        text1: 'Nome',
        text2: 'Tel: (32) 99999-9999',
        text3: 'CPF: 123.456.789-00',
      },
      visible: true,
      interval: null,
      positionMode: 9,
      currentCorner: '',
      currentPosition: '',
      startSelectedDrmGroup: {},
      question: '',
      savedTabState: 0,
      namesIntegrations: {
        cademi: 'Cademí',
        memberkit: 'MemberKit',
        'the-members': 'The Members',
        xgrow: 'Xgrow',
        ticto: 'Ticto',
        eduzz: 'Eduzz',
        hotmart: 'Hotmart',
        api: i18n.t('message.pages.drm.api'),
        default: i18n.t('message.pages.drm.api'),
      },
    }
  },

  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      isTabletBreakpoint: (state) => state.user.isTabletBreakpoint,
    }),
    ...mapState({
      mainFolders: (state) => state.user.mainFolders,
    }),
    positions() {
      if (this.positionMode == 9)
        return [
          'top-left',
          'top-center',
          'top-right',
          'center-left',
          'center',
          'center-right',
          'bottom-left',
          'bottom-center',
          'bottom-right',
        ]
      else return ['top-left', 'top-right', 'bottom-left', 'bottom-right']
    },
    savedTab() {
      return this.savedTabState
    },
    hasIncompleteIntegration() {
      return (group) => {
        const source = group.webhook_source_name || 'api'
        const isHotmartOrEduzz = ['hotmart', 'eduzz'].includes(source)
        return isHotmartOrEduzz && !group.token_verification
      }
    },
    getAnimationClass() {
      const map = {
        'top-left': 'slide-top-left',
        'top-center': 'slide-top-center',
        'top-right': 'slide-top-right',
        'center-left': 'slide-center-left',
        center: 'slide-center',
        'center-right': 'slide-center-right',
        'bottom-left': 'slide-bottom-left',
        'bottom-center': 'slide-bottom-center',
        'bottom-right': 'slide-bottom-right',
      }

      return map[this.currentPosition] || ''
    },
    noChanges() {
      return (
        _.isEqual(this.startSelectedDrmGroup, this.selectedDrmGroup) &&
        _.isEqual(this.selectedWebhookValue, this.startWebhookValue)
      )
    },
    getBoxStyle() {
      const pos = this.currentPosition

      const map = {
        'top-left': { top: '10px', left: '10px' },
        'top-center': {
          top: '10px',
          left: '30%',
          transform: 'translateX(-50%)',
        },
        'top-right': { top: '10px', right: '10px' },
        'center-left': {
          top: '40%',
          left: '10px',
          transform: 'translateY(-50%)',
        },
        center: { top: '40%', left: '30%', transform: 'translate(-50%, -50%)' },
        'center-right': {
          top: '40%',
          right: '10px',
          transform: 'translateY(-50%)',
        },
        'bottom-left': { bottom: '10px', left: '10px' },
        'bottom-center': {
          bottom: '10px',
          left: '30%',
          transform: 'translateX(-50%)',
        },
        'bottom-right': { bottom: '10px', right: '10px' },
      }
      const config = this.selectedDrmGroup?.config || {}
      const baseFontSize = parseFloat(config['font-size']) || 12
      return {
        position: 'absolute',
        backgroundColor: '#f3f3f3',
        marginTop: '8px',
        padding: '8px',
        borderRadius: '4px',
        background: config['box-color']?.toString(),
        fontSize:
          (this.isMobileBreakpoint ? baseFontSize * 0.4 : baseFontSize) + 'px',
        color: config['font-color']?.toString(),
        fontWeight: 500,
        width: this.isMobileBreakpoint ? 'auto' : 'auto',
        top: 'auto',
        bottom: 'auto',
        left: 'auto',
        right: 'auto',
        overflow: 'hidden',
        ...(map[pos] || {}),
      }
    },
    transitionName() {
      return 'slide-' + this.currentPosition.replace('_', '-')
    },
    questionComputed() {
      return this.question
    },
    allDrmGroups() {
      return [...this.allDrmGroupsState]
    },
    platformLabel() {
      let source = this.selectedSourceWebhook || 'api'
      if (source === 'default') source = 'api'

      const platformLabels = {
        hotmart: 'Hotmart',
        eduzz: 'Eduzz',
        memberkit: 'Memberkit',
        'the-members': 'The Members',
        ticto: 'Ticto',
        cademi: 'Cademí',
        xgrow: 'Xgrow',
        api: i18n.t('message.pages.drm.api'),
      }
      return platformLabels[source]
    },
    platformSvg() {
      let source = this.selectedSourceWebhook || 'api'
      if (source === 'default') source = 'api'

      const platformIcons = {
        hotmart,
        eduzz,
        memberkit,
        'the-members': themembers,
        ticto,
        cademi,
        xgrow,
        api,
      }
      return platformIcons[source]
    },
    selectedDrmGroup() {
      return { ...this.selectedDrmGroupState }
    },
    embedPage() {
      return `<div style="position:relative;padding-top:56.25%;">
        <iframe id="panda-player"  style="
              border: none;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            " src="https://player-vz-ded14ebd-85a.tv.pandavideo.com.br/embed/?v=c965679f-bbda-4997-962f-d6a501004c10&pandaBranding=false&controls=false&autoplay=true&restartAfterEnd=true&mutedIndicatorIcon=false&muted=true" style="border:none;position:absolute;top:0;height:100%;width:100%" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"allowfullscreen=true>
      </iframe>
      </div>`
    },
    isLoadingCsvComputed() {
      return this.isLoadingCsv
    },
    getQuantityInsideGroup() {
      return (group) => {
        const directVideos = parseInt(group?.video_ids?.length || 0)
        const videosInFolders = this.getVideosCountInsideFolders(
          group.folder_ids
        )
        const total = directVideos + videosInFolders

        const messageKey = `message.pages.drm.tableRow.${
          total === 1 ? 'video' : 'videos'
        }`
        return this.$t(messageKey, { count: total })
      }
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleActivationGroup(group) {
      this.$root.$emit('drmActivateGroupModal', {
        group,
        countVideos: this.getQuantityInsideGroup(group),
      })
    },
    countVideosInChildFolders(allFolders, folderId) {
      const childFoldersIds = []

      // Função recursiva para procurar pastas com parent_folder_id igual a folderId
      function findChildFolders(currentFolderId) {
        const foldersWithParent = allFolders.filter(
          (folder) => folder.parent_folder_id === currentFolderId
        )

        for (let folder of foldersWithParent) {
          childFoldersIds.push(folder.id)
          findChildFolders(folder.id)
        }
      }

      findChildFolders(folderId)

      // Soma os video_count das pastas encontradas
      const totalChildFoldersVideoCount = childFoldersIds.reduce(
        (acc, currentFolderId) => {
          const folder = allFolders.find((f) => f.id === currentFolderId)
          const videoCount = folder ? parseInt(folder.videos_count, 10) ?? 0 : 0
          return acc + videoCount
        },
        0
      )

      return totalChildFoldersVideoCount
    },
    calculateVideoCount(folderId) {
      const allFolders = this.mainFolders

      const parentFolders = allFolders.filter(
        (folder) => folder.id === folderId
      )

      const videosCountInChildFolders = this.countVideosInChildFolders(
        allFolders,
        folderId
      )

      const videoCountInParentFolders = parentFolders
        .map((folder) => parseInt(folder.videos_count, 10) || 0)
        .reduce((acc, count) => acc + count, 0)

      return videosCountInChildFolders + videoCountInParentFolders
    },
    getVideosCountInsideFolders(folderIds) {
      if (!folderIds?.length) return 0

      return folderIds.reduce(
        (total, folderId) => total + this.calculateVideoCount(folderId),
        0
      )
    },
    async handleDeleteGroup(group) {
      const countVideos = this.getQuantityInsideGroup(group)
      this.$root.$emit('drmRemoveGroupModal', {
        group,
        countVideos,
      })
    },
    checkImportStatus() {
      const key = `uploadCsv_${this.selectedDrmGroup.id}`
      const importIdsRaw = localStorage.getItem(key)
      this.isLoadingCsv = true
      if (!importIdsRaw) {
        this.isLoadingCsv = false
        return
      }

      const importIds = JSON.parse(importIdsRaw)

      if (!Array.isArray(importIds) || !importIds.length) {
        localStorage.removeItem(key)
        this.isLoadingCsv = false
        return
      }

      const statusPromises = importIds.map((id) =>
        drmApi
          .getStatusImportDrm(id)
          .then((res) => {
            return { id, status: res.data.status }
          })
          .catch((error) => {
            console.error(`Erro ao verificar status do ID ${id}:`, error)
            return { id, status: 'erro' }
          })
      )

      Promise.all(statusPromises).then((results) => {
        const remainingIds = results
          .filter((r) => r.status !== 'completed')
          .map((r) => r.id)

        if (remainingIds.length) {
          localStorage.setItem(key, JSON.stringify(remainingIds))
        } else {
          localStorage.removeItem(key)
        }

        if (!localStorage.getItem(key)) {
          this.isLoadingCsv = false
        }
      })
    },
    startWatchingImports() {
      this.checkImportStatus()
      this.importStatusInterval = setInterval(
        this.checkImportStatus,
        3 * 60 * 1000
      )
    },

    stopWatchingImports() {
      clearInterval(this.importStatusInterval)
      this.importStatusInterval = null
    },
    publish() {
      const savedTab = localStorage.getItem('activeDrmTab')

      this.$root.$emit(`publish-${this.eventPublish[savedTab]}`)
    },
    openEditIngration() {
      this.$root.$emit(
        'drmIntegrationFlow',
        this.selectedSourceWebhook,
        this.selectedDrmGroup,
        true
      )
    },
    getRandomPosition(exclude) {
      const options = this.positions.filter((p) => p !== exclude)
      return options[Math.floor(Math.random() * options.length)]
    },
    changePosition() {
      this.visible = false
      setTimeout(() => {
        this.currentPosition = this.getRandomPosition(this.currentPosition)
        this.$nextTick(() => {
          this.visible = true
        })
      }, 3000)
    },
    startCycle() {
      this.currentPosition = this.getRandomPosition('')
      this.interval = setInterval(this.changePosition, 6000)
    },
    stopCycle() {
      clearInterval(this.interval)
    },
    openModal() {
      this.openSelectPanda = true
    },
    async handleStatusDRM() {
      await drmApi.drmUpdateVideos(this.selectedDrmGroup.id, {
        active: this.selectedDrmGroup.active,
      })
    },
    hasHistory() {
      return window.history.length > 2
    },
    copyToClipboard(value) {
      navigator.clipboard
        .writeText(value || this.selectedDrmGroup.id)
        .then(() => {
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            type: 'success',
            text: i18n.t('message.copiedToClipboard'),
          })
        })
        .catch((err) => {
          console.error('Erro ao copiar:', err)
        })
    },
    handleBackToListing() {
      if (this.hasHistory()) {
        this.$router.go(-1)
        return
      }
      this.$router.push({ name: 'DRM' }).catch(() => {})
    },
    async getDrmGroups() {
      try {
        let ret = await drmApi.getDrmGroups()
        this.selectedDrmGroupState = ret.data?.find(
          (group) => group.id == this.$route.params.id
        )
        this.allDrmGroupsState = ret.data
        this.startSelectedDrmGroup = _.cloneDeep(this.selectedDrmGroupState)
      } catch (error) {
        console.log(error)
      }
    },
    async getUserWebhooks() {
      try {
        let ret = await drmApi.listGroupWebhooks(this.selectedDrmGroup.id)
        this.startWebhookValue = ret.data
        this.selectedWebhookValue = ret.data
        if (ret.data?.source_name)
          this.selectedSourceWebhook = ret.data.source_name
        this.startWebhookValue = _.cloneDeep(this.selectedWebhookValue)
        if (ret.data) {
          this.hottok = ret.data.token_verification
        }
      } catch (e) {
        this.isFetchingWebhookInfo = false
        this.selectedSourceWebhook = 'api'
        console.log('e', e)
      }
    },
    async getImportCsvStatus() {
      try {
        let ret = await drmApi.getStatusImportDrm(this.selectedDrmGroup.id)
        this.status = ret.data

        if (ret.data?.source_name)
          this.selectedSourceWebhook = ret.data.source_name

        if (ret.data) {
          this.hottok = ret.data.token_verification
        }
      } catch (e) {
        this.isFetchingWebhookInfo = false
        this.selectedSourceWebhook = 'API'
        console.log('e', e)
      }
    },
    addKey() {
      this.$root.$emit('openDrmSecretKey', {
        group: this.selectedDrmGroup,
        item: '',
        edit: false,
      })
    },
    discardChanges() {
      Object.assign(this.selectedDrmGroupState, this.startSelectedDrmGroup)
      this.selectedWebhookValue = _.cloneDeep(this.startWebhookValue)
      this.$root.$emit('discard-changes', this.selectedDrmGroupState)
    },
  },
  async mounted() {
    this.loading = true
    await this.getDrmGroups()
    await this.getUserWebhooks()
    this.$root.$on('reloadDrm', async () => {
      this.loading = true
      await this.getDrmGroups()
      await this.getUserWebhooks()
      this.loading = false
    })
    this.$root.$on('reloadDrmWatermark', async () => {
      await this.getUserWebhooks()
      await this.getDrmGroups()
    })
    if (localStorage.getItem(`uploadCsv_${this.selectedDrmGroup.id}`))
      this.startWatchingImports()
    this.$root.$on('import-csv', () => {
      this.startWatchingImports()
    })
    this.$root.$on('changePreview', (selectedDrmGroup) => {
      this.$set(this.selectedDrmGroupState, 'config', {
        ...this.selectedDrmGroupState.config,
        ...selectedDrmGroup.config,
      })
      this.selectedDrmGroupState = _.cloneDeep(selectedDrmGroup)
    })
    this.$root.$on('updateDrmGroupStart', (startSelectedDrmGroup) => {
      this.$set(this.selectedDrmGroupState, 'config', {
        ...this.selectedDrmGroupState.config,
        ...startSelectedDrmGroup.config,
      })
      this.startSelectedDrmGroup = _.cloneDeep(this.selectedDrmGroupState)
    })
    this.$root.$on('updateDrmGroup', ({ active }) => {
      this.$set(this.selectedDrmGroupState, 'active', active)
      this.startSelectedDrmGroup.active = active
    })
    this.$root.$on('isBtnloading', (loading) => {
      this.isBtnloading = loading
    })
    this.$root.$on('changeTab', (tab) => {
      this.savedTabState = tab
    })
    this.$root.$on('changeWatermark', (startWebhookValue) => {
      console.log(startWebhookValue)
      if (
        startWebhookValue.model_string1 &&
        startWebhookValue.model_string2 &&
        startWebhookValue.model_string3
      )
        this.emptyInput = true
      this.selectedWebhookValue = _.cloneDeep(startWebhookValue)
      // Object.assign(this.selectedDrmGroupState, selectedDrmGroup)
    })
    this.savedTabState = localStorage.getItem('activeDrmTab')
    this.$root.$on('change-type-animation', (position) => {
      this.stopCycle()
      this.positionMode = position
      if (position == 9)
        this.positions = [
          'top-left',
          'top-center',
          'top-right',
          'center-left',
          'center',
          'center-right',
          'bottom-left',
          'bottom-center',
          'bottom-right',
        ]
      else
        this.positions = [
          'top-left',
          'top-right',
          'bottom-left',
          'bottom-right',
        ]
      this.startCycle()
    })
    this.$root.$on('changeQuestion', (question) => {
      this.question = question
      this.$set(this.selectedDrmGroupState, 'config_player', {
        watermark_question: question,
      })
      if (!question.length) this.emptyInput = true
      else this.emptyInput = false
      console.log(this.selectedDrmGroupState)
    })

    this.$root.$on('notFocus', (question) => {
      this.question = question
      console.log(question)
    })
    if (this.selectedDrmGroupState.config['animation-type'] == 'default')
      this.positionMode = 4
    else this.positionMode = 9
    this.startCycle()
    this.$root.$on('changeLanguage', () => {
      this.namesIntegrations = {
        cademi: 'Cademí',
        memberkit: 'MemberKit',
        'the-members': 'The Members',
        xgrow: 'Xgrow',
        ticto: 'Ticto',
        eduzz: 'Eduzz',
        hotmart: 'Hotmart',
        api: i18n.t('message.pages.drm.api'),
        default: i18n.t('message.pages.drm.api'),
      }
    })
    this.selectedWebhookValue = _.cloneDeep(this.startWebhookValue)
    this.loading = false
  },
  beforeDestroy() {
    this.stopCycle()
    this.$root.$off('changeQuestion')
    this.$root.$off('notFocus')
  },
}
</script>
<style lang="scss" scoped>
.animated-box {
  transition: all 0.5s ease;
}

@keyframes slide-top-left {
  0% {
    transform: translate(-150%, -150%);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes slide-top-center {
  0% {
    transform: translateY(-150%);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes slide-top-right {
  0% {
    transform: translate(150%, -150%);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes slide-center-left {
  0% {
    transform: translateX(-150%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes slide-center {
  0% {
    transform: translate(-150%, -150%);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes slide-center-right {
  0% {
    transform: translateX(150%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes slide-bottom-left {
  0% {
    transform: translate(-150%, 150%);
  }

  100% {
    transform: translate(0, 0);
  }
}

@keyframes slide-bottom-center {
  0% {
    transform: translateY(150%);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes slide-bottom-right {
  0% {
    transform: translate(150%, 150%);
  }

  100% {
    transform: translate(0, 0);
  }
}

.slide-top-left {
  animation: slide-top-left 0.6s ease forwards;
}

.slide-top-center {
  animation: slide-top-center 0.6s ease forwards;
}

.slide-top-right {
  animation: slide-top-right 0.6s ease forwards;
}

.slide-center-left {
  animation: slide-center-left 0.6s ease forwards;
}

.slide-center {
  animation: slide-center 0.6s ease forwards;
}

.slide-center-right {
  animation: slide-center-right 0.6s ease forwards;
}

.slide-bottom-left {
  animation: slide-bottom-left 0.6s ease forwards;
}

.slide-bottom-center {
  animation: slide-bottom-center 0.6s ease forwards;
}

.slide-bottom-right {
  animation: slide-bottom-right 0.6s ease forwards;
}

.w-full {
  width: 100%;
}

.input-name {
  border: 1px solid varFigma(neutral-95-lightest);
  width: 100%;
  padding-left: 8px;
}

.grid {
  display: grid;
  grid-template-areas: 'preview' 'control' 'spacer' 'footer';
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  column-gap: 0;
  row-gap: 0;

  box-shadow: none !important;

  overflow: hidden;
  height: 100%;

  @media (min-width: 1200px) {
    grid-template-areas:
      'preview control'
      'preview spacer'
      'preview footer';
    grid-template-columns: 50% auto;
    grid-template-rows: auto 1fr auto;
  }

  &__preview {
    grid-area: preview;
    overflow: hidden;
    padding: $spacing-10;

    &--container {
      margin: 0 auto;
      width: 75vw;

      @media (min-width: 760px) {
        width: 50vw;
      }

      @media (min-width: 1200px) {
        width: 100%;
      }
    }
  }

  &__control {
    grid-area: control;

    overflow-y: auto;
    overflow-x: hidden;

    height: 100%;
    padding: $spacing-10 $spacing-09 0 $spacing-09;
    margin-right: 2px;

    @media (min-width: 1200px) {
      border-left: 1px solid varFigma(neutral-95-lightest) !important;
    }

    @media (max-width: 1199px) {
      border-top: 1px solid varFigma(neutral-95-lightest) !important;
    }

    &--items {
      display: grid;
      padding-top: 0 !important;
    }

    &--item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px !important;

      &:hover {
        background-color: varFigma(neutral-99);
      }

      & .v-input::v-deep {
        padding: 0 !important;

        & .v-input--selection-controls__input {
          margin-right: 0 !important;
        }
      }
    }
  }

  &__footer {
    grid-area: footer;

    @media (width >=1200px) {
      border-left: 1px solid varFigma(neutral-95-lightest) !important;

      & .actions-row {
        margin-right: 100px;
      }
    }

    @media (width < 1200px) {
      & .actions-row {
        .spacer {
          display: none;
        }

        justify-content: center;
      }
    }

    & .actions-row {
      padding: $spacing-07 0;
    }

    &.actions-column {
      .divider-div {
        padding: 0 $spacing-10;
      }
    }
  }

  &__spacer {
    grid-area: spacer;

    @media (width >=1200px) {
      border-left: 1px solid varFigma(neutral-95-lightest) !important;
    }
  }

  &__resources {
    &--items {
      display: grid;
      padding-top: 0 !important;
    }

    &--item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px !important;

      &:hover {
        background-color: varFigma(neutral-99);

        &.affiliate {
          background-color: inherit;
        }
      }

      & .v-input::v-deep {
        padding: 0 !important;

        & .v-input--selection-controls__input {
          margin-right: 0 !important;
        }
      }
    }

    &--label {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .body-regular-smaller {
        color: varFigma(neutral-40-light);
      }
    }
  }
}

.grid__preview {
  overflow: auto;
}

.grid__details {
  margin-top: 16px;
  background: varFigma(neutral-100-white);
  border: 1px solid varFigma(neutral-95-lightest);
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-radius: 4px;
}
</style>
